export default [
  {
    path: 'M64 64m102.4 0l691.2 0q102.4 0 102.4 102.4l0 691.2q0 102.4-102.4 102.4l-691.2 0q-102.4 0-102.4-102.4l0-691.2q0-102.4 102.4-102.4Z',
    fill: '#102929',
  },
  {
    path: 'M857.6 983.04H166.4a125.5808 125.5808 0 0 1-125.44-125.44V166.4a125.5808 125.5808 0 0 1 125.44-125.44h691.2a125.5808 125.5808 0 0 1 125.44 125.44v691.2a125.5808 125.5808 0 0 1-125.44 125.44zM166.4 87.04a79.4496 79.4496 0 0 0-79.36 79.36v691.2a79.4496 79.4496 0 0 0 79.36 79.36h691.2a79.4496 79.4496 0 0 0 79.36-79.36V166.4a79.4496 79.4496 0 0 0-79.36-79.36z',
    fill: '#00E6D2',
  },
  {
    path: 'M230.656 329.216h172.032c68.608 0 111.104 37.376 111.104 95.744 0 44.032-19.456 80.384-63.488 92.672v1.024c42.496 8.192 51.2 39.424 54.784 75.264 3.072 35.84 1.024 75.776 21.504 100.864H472.32c-13.824-14.848-6.144-54.272-13.312-90.112-5.12-35.84-13.824-66.048-60.928-66.048h-118.784v156.16h-48.64z m150.016 168.448c45.568 0 84.48-11.776 84.48-65.024 0-35.84-19.456-62.464-65.024-62.464h-120.832v127.488zM574.208 329.216h43.52v139.776h1.024c14.336-31.744 51.712-45.056 83.456-45.056 69.632 0 91.136 39.936 91.136 96.768v174.08h-43.52v-179.2c0-32.256-20.48-53.248-53.76-53.248-52.736 0-78.336 35.328-78.336 82.944v149.504h-43.52z',
    fill: '#00E6D2',
  },
]
